import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-sec" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Access Denied", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("This content is not available for a Guest user."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Please "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/contact",
    target: "popup"
  }, "contact us"),
  /*#__PURE__*/_createTextVNode(" to explore AK View")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Error", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Failed to load components.", -1)
const _hoisted_6 = { class: "inner-sec" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Training and Education", -1)
const _hoisted_8 = { class: "components container" }
const _hoisted_9 = { class: "grid-title" }
const _hoisted_10 = {
  key: 0,
  class: "badge"
}
const _hoisted_11 = { class: "grid-content" }
const _hoisted_12 = { class: "Q-section" }
const _hoisted_13 = { class: "inner-Q-section" }
const _hoisted_14 = { class: "q-section-wrap" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "demo-available badge"
}
const _hoisted_17 = {
  key: 1,
  class: "badge"
}
const _hoisted_18 = ["href", "alt", "onClick"]
const _hoisted_19 = {
  key: 0,
  class: "demo-available badge"
}

import { computed, ref, watch, onMounted } from "vue";
import { useStore } from "@/store";
import { useRouter, useRoute } from "vue-router";
import { api } from "@/service/api";

import AlertDialog from "@/components/AlertDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AircraftComponentsPage',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const components = ref<any>([]);

const isDemoUser = ref(false);

const noGuestAlertDialog = ref<typeof AlertDialog | null>(null);
const failedToLoadAlertDialog = ref<typeof AlertDialog | null>(null);

// model is derived from vue-router
const model = computed(() => {
  const model = route.params.model as string;
  return model.toUpperCase();
});

const toggleExpand = (node) => {
  node.isExpanded = !node.isExpanded;
};

const rebuildListForDemoTasks = (node) => {
  let demoAvailable = false;
  if (Array.isArray(node)) {
    for (const child of node) {
      rebuildListForDemoTasks(child);
    }
    return; // The first level is pure array
  }
  if (Array.isArray(node.children)) {
    for (const child of node.children) {
      demoAvailable = demoAvailable || rebuildListForDemoTasks(child);
    }
  }

  if (node.demo === true) {
    demoAvailable = true;
  }

  if (demoAvailable) {
    node.demo = true;
  }

  return demoAvailable;
}

const gotoWatch = (e, isDemoAvailable) => {
  if (isDemoUser.value && !isDemoAvailable) {
    e.preventDefault();
    noGuestAlertDialog.value?.open();
    return false;
  }

  return true;
}

onMounted(async () => {
  components.value = [];

  // isDemoUser.value = store.user?.roles?.includes("group:demo") || false;
  isDemoUser.value = true; // Override for archive mode: always true

  console.log({ ...store.user });

  const res = await api.get(`/index/components/${model.value}`);
  let _components: any[] = [];
  if (res.status < 400) {
    _components = res.data;
  } else {
    failedToLoadAlertDialog.value?.open();
    return;
  }

  if (isDemoUser.value === true) {
    rebuildListForDemoTasks(_components);
  }

  components.value = _components;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AlertDialog, {
      ref_key: "noGuestAlertDialog",
      ref: noGuestAlertDialog
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }, 512),
    _createVNode(AlertDialog, {
      ref_key: "failedToLoadAlertDialog",
      ref: failedToLoadAlertDialog
    }, {
      default: _withCtx(() => [
        _hoisted_4,
        _hoisted_5
      ]),
      _: 1
    }, 512),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("h3", null, _toDisplayString(model.value), 1),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(components.value, (component, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "gird-sec",
            key: index
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(component.label) + " ", 1),
                (component.badge)
                  ? (_openBlock(), _createElementBlock("sub", _hoisted_10, _toDisplayString(component.badge), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("section", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.children, (part) => {
                      return (_openBlock(), _createElementBlock("dl", {
                        key: part.label
                      }, [
                        _createElementVNode("dt", {
                          onClick: ($event: any) => (toggleExpand(part))
                        }, [
                          _createElementVNode("p", {
                            class: _normalizeClass({ 'link-disabled': isDemoUser.value && !part.demo })
                          }, [
                            _createTextVNode(_toDisplayString(part.label) + " ", 1),
                            (isDemoUser.value && part.demo === true)
                              ? (_openBlock(), _createElementBlock("sub", _hoisted_16, "DEMO"))
                              : _createCommentVNode("", true),
                            (part.badge)
                              ? (_openBlock(), _createElementBlock("sub", _hoisted_17, _toDisplayString(part.badge), 1))
                              : _createCommentVNode("", true)
                          ], 2)
                        ], 8, _hoisted_15),
                        _createElementVNode("dd", {
                          class: _normalizeClass({ 'dd-none': part.isExpanded })
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(part.children, (task) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: task.link
                            }, [
                              _createElementVNode("a", {
                                class: _normalizeClass({ 'link-disabled': isDemoUser.value && !task.demo }),
                                href: task.link,
                                alt: task.label,
                                onClick: (e) => gotoWatch(e, task.demo)
                              }, [
                                _createTextVNode(_toDisplayString(task.label), 1),
                                (isDemoUser.value && task.demo === true)
                                  ? (_openBlock(), _createElementBlock("sub", _hoisted_19, "DEMO"))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_18)
                            ]))
                          }), 128))
                        ], 2)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})